<template>
	<div>
		<el-dialog :title="$t('course_index.student_list')"  data-title="学生列表" width="1200px" :close-on-click-modal="false" :visible="isdialog" :before-close="guanbitanchu">
			<div class="filter-inline-panel cle">
				<el-form size="mini" class="filter-panel">
					<el-form-item :label="$t('course_index.theme')" prop="user_id">
						<el-input :value="
							(lang=='cn'?course_info.theme_cn:course_info.theme)+','+
							(lang=='cn'?course_info.teacher_name_cn:course_info.teacher_name)+','+
							getTime_week(course_info.have_date_time)+','+
							getTime_us(course_info.start_date,'mmddyyyy')+'~'+getTime_us(course_info.end_date,'mmddyyyy')+','+
							getTime_us(course_info.start_time,'hh:ii')+'~'+getTime_us(course_info.end_time,'hh:ii')
						" type="textarea" class="w100" :autosize="{ minRows: 1, maxRows: 1}"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<el-table :data="list" border size="mini">
				<el-table-column prop="parent_name" align="center" :label="$t('student_list.parent_name')" data-name="家长姓名" width="100"></el-table-column>
				<el-table-column prop="tel" align="center" :label="$t('student_list.tel')" data-name="电话" width="130"></el-table-column>
				<el-table-column prop="wechat_id" align="center" :label="$t('student_list.wechat')" data-name="微信ID"></el-table-column>
				<el-table-column prop="name" align="center" :label="$t('student_list.name')" data-name="学生名称" width="130">
					<template slot-scope="scope">
						<el-image v-if="scope.row.thumb" style="width: 50px; height: 50px" :src="scope.row.thumb" fit="contain"></el-image>
						<div>{{scope.row.name_cn}}</div>
						<div>{{scope.row.name}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="age" align="center" :label="$t('student_list.age')" data-name="年龄">
					<template slot-scope="scope"> {{scope.row.age>50?'成人':scope.row.age}} </template>
				</el-table-column>
				<el-table-column prop="class_date_time" align="center" :label="$t('parent_index.trial_substitute')" data-name="试听" width="90">
					<template slot-scope="{row}">
						<p v-if="row.trip_course_type==1">{{$t('parent_index.trial_listening')}}</p>
						<p v-if="row.trip_course_type==2">{{$t('parent_index.substitute')}}</p>
						<p v-if="row.class_date_time">{{getTime_us(row.class_date_time,'mmddyyyy')}} {{getTime_us(row.class_date_time,'hh:ii')}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="course_form" align="center" :label="$t('student_list.fields') " data-name="自定义字段"  width="100">
					<template slot-scope="{row}">
						<div class="tl" v-for="(item,index) in row.course_form">{{lang=='cn'?item.field_name_cn:item.field_name}}：<span style="cursor:pointer;" @click="field_click(item.value)">{{item.value}}</span></div>
					</template>
				</el-table-column>
				<el-table-column prop="remarks" align="center" :label="$t('student_list.remarks')" data-name="备注" width="100"></el-table-column>
				<el-table-column prop="user_remarks" align="center" :label="$t('student_list.parent_note')" data-name="家长备注" width="100"></el-table-column>
				<el-table-column prop="pay_price" align="center" :label="$t('student_list.pay_price')" data-name="实际支付金额" width="100"></el-table-column>
				<el-table-column prop="per_class_price" align="center" :label="$t('student_list.per_class_price')" data-name="每课金额" width="100"></el-table-column>
				<el-table-column prop="create_time" align="center" :label="$t('course_index.create_time')" data-name="报名时间">
					<template slot-scope="scope">{{getTime_us(scope.row.create_time,'mmddyyyy')}}</template>
				</el-table-column>
			</el-table>
			<div class="title">{{$t('journal.title')}}</div>
			<el-table :data="record_list" border size="mini">
				<el-table-column :prop="lang=='cn'?'course_name_cn':'course_name'" align="center" :label="$t('journal.name')"></el-table-column>
				<el-table-column prop="email" align="center" :label="$t('journal.admin_email')"></el-table-column>
				<el-table-column prop="child_name" align="center" :label="$t('journal.child_name')"></el-table-column>
				<el-table-column prop="user_name" align="center" :label="$t('journal.user_name')"></el-table-column>
				<el-table-column prop="create_time" align="center" :label="$t('journal.create_time')">
					<template slot-scope="scope">{{getTime_us(scope.row.create_time,'mmddyyyy')}}</template>
				</el-table-column>
				<el-table-column prop="action" align="center" :label="$t('index.operation')"></el-table-column>
				<el-table-column prop="remarks" align="center" :label="$t('student_list.remarks')"></el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>
<script>
export default {
	props: {
		isdialog: {
			type: Boolean,
			default: false
		},
		id: {
			type: Number,
			default: 0
		},
	},
	data() {
		return {
			list: [],
			course_info: {},
			record_list:[],
		}
	},
	watch: {
		isdialog(v){
			if (v) {
				this.init();
			}
		},
	},
	// 初始事件
	mounted: function () {
	},
	// 事件
	methods: {
		// 初始化
		init() {
			var this_ = this;
			var url = "courseClasses";
			var datas = {
				course_id: this_.id,
			};
			this_.$post(url, datas).then((res) => {
				this_.list = res.student;
				this_.course_info = res.course_info;
			})
			var url = "adminStudentRecord";
			var datas = {
				course_id: this_.id,
				type:'course',
				page:1,
				num:10000,
			};
			this_.$post(url, datas).then((res) => {
				this_.record_list = res.list;
			})
		},
		guanbitanchu(){
			this.list=[];
			this.$emit("guanbitanchu");
		},
		field_click(value){
			if(value.indexOf('http')!=-1){
				var url=value.slice(value.indexOf('http'));
				window.open(url);
			}
		},

	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.title{
	text-align: center;
	font-size: 20px;
	margin-top: 10px;
	line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/teacher_student_list_inventory.vue